import { Component, Injectable, inject } from '@angular/core';
import { NewplaBaseComponent2, NewplaPageUtils } from '@newpla/ng-common';
import { Bs5ModalCtrl } from '@newpla/ng-lib';
import { NpTaskAll } from '@newpla/ts-common';
import { CollectionView, DataMap, NpFlexGridCtrl } from '@newpla/wijmo';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NpxCommonModule } from '../../../../newpla-npx-ng17/src/_shared-modules/npx-common.module';
import { NpxFormsModule } from '../../../../newpla-npx-ng17/src/_shared-modules/npx-forms.module';
import { NpxWijmoGridModule } from '../../../../newpla-npx-ng17/src/_shared-modules/npx-wijmo-grid.module';
import { SlsNovaPageLoading } from '../../config/sls-nova-page-loading';

/** 출고요청 검증 결과 모달. 결과 목록(checkResults)을 넘겨 연다. */
@Injectable({
  providedIn: 'root'
})
export class PdiOutboundOrderCheckResultModalOpenService {
  private ngbModal = inject(NgbModal);
  openModal(checkResults: any[], opts?: { title?: string }) {
    let modal = this.ngbModal.open(PdiOutboundOrderCheckResultModalComponent, { size: 'lg', scrollable: true, backdrop: 'static' });
    modal.componentInstance.checkResults = checkResults;
    modal.componentInstance.title = opts?.title;
    return modal.result;
  }
}

@Component({
  selector: 'pdi-outbound-order-check-result-modal',
  standalone: true,
  imports: [NpxCommonModule, NpxFormsModule, NpxWijmoGridModule],
  templateUrl: './pdi-outbound-order-check-result-modal.component.html',
  styleUrl: './pdi-outbound-order-check-result-modal.component.scss'
})
export class PdiOutboundOrderCheckResultModalComponent extends NewplaBaseComponent2 {

  ///////////////////////////////////////////////////////////////////////////////////////////////////// BROWSER INIT
  browserInited: boolean = false;
  override browserNgOnInit = async () => {
    try {
      const taskAll = new NpTaskAll();
      taskAll.add(SlsNovaPageLoading.wait());
      await taskAll.run();

      this.modalInit();
      this.browserInited = true;
    } catch (e) {
      NewplaPageUtils.browserInitError(e);
      this.activeModal.dismiss();
    }
  };

  ///////////////////////////////////////////////////////////////////////////////////////////////////// DATA

  checkResults: any[] = [];
  title?: string;

  dataMap = {
    type: new DataMap([{ id: 'ERROR', text: '오류' }, { id: 'ALERT', text: '주의' }], 'id', 'text'),
    category: new DataMap([{ id: 'VEHICLE', text: '차량' }, { id: 'WORK_ORDER', text: 'WO' }, { id: 'DELIVERY', text: '운송' }], 'id', 'text'),
  }

  get errorCnt(): number {
    return this.checkResults.filter(r => r.type === 'ERROR').length;
  }

  get alertCnt(): number {
    return this.checkResults.filter(r => r.type === 'ALERT').length;
  }

  ///////////////////////////////////////////////////////////////////////////////////////////////////// INJECT

  activeModal = inject(NgbActiveModal);
  modalCtrl = new Bs5ModalCtrl({ drag: true, fullscreen: true });

  // 그리드 /////////////////////////////////////////////////////////////////////////////////////////////////////

  flexGrid1Cv: CollectionView = new CollectionView([], {});
  flexGrid1Ctrl: NpFlexGridCtrl = new NpFlexGridCtrl({
    selector: 'MULTI',
    flexGridId: window.location.pathname + '#pdiOutboundOrderCheck#flexGrid1',
    excelDownload: false,
    excelFileName: '출고요청_검증결과'
  });

  modalInit() {
    if (!this.checkResults) this.checkResults = [];
    // 오류를 먼저 보여준다
    this.flexGrid1Cv.sourceCollection = [...this.checkResults].sort((a, b) => (a.type === b.type ? 0 : a.type === 'ERROR' ? -1 : 1));
  }

  /** 수준 셀 배지 색 */
  typeBadgeClass(type: string): string {
    return type === 'ERROR'
      ? 'bg-danger-subtle text-danger-emphasis border-danger-subtle'
      : 'bg-warning-subtle text-warning-emphasis border-warning-subtle';
  }

}
